import { Component } from '@angular/core';

@Component({
  selector: 'app-psychology',
  templateUrl: './psychology.component.html',
  styleUrls: ['./psychology.component.scss']
})
export class PsychologyComponent {

}
